'use strict';
angular.module('pickReportsModule', []).
controller('confirmPickReportsCtrl', function($scope, $modalInstance, $validation, planCtrModalService, commandService, topic, reports) {
    $scope.topic = topic;
    $scope.reports = reports;
    $scope.showcheckpage = true;
    $scope.tags = [{ "value": "0", "label": "普通" },
        { "value": "1", "label": "重要" },
        { "value": "2", "label": "紧急" },
        { "value": "3", "label": "敏感" },
        { "value": "4", "label": "精选" }
    ];
    var init = function() {
        angular.forEach($scope.reports, function(report, index) {
             report.selectedTag=angular.copy($scope.tags[0]);
        });
    } 
    $scope.close = function() {
        $modalInstance.dismiss();
    };
    $scope.submit = function(form) {
        var flag = $validation.checkValid(form);
        if (flag) {
            var reportsArr = [];
            angular.forEach($scope.reports, function(report, index) {
                reportsArr.push({
                    ReportId: report.REPORTID,
                    KeyWords: report.keywords,
                    Statement: report.statement,
                    Flag:report.selectedTag.value,
                    SelectedContent: report.SelectedContent ? report.SelectedContent : ""
                })
            });
            commandService.invoke('pushSelected', { json: JSON.stringify(reportsArr) }).then(function(data) {
                $modalInstance.close(data);
            });
        } else {
            angular.forEach($scope.reports, function(report, index) {
                if (!report.statement || !report.statement.length > 0) {
                    report.statementTip = true;
                }
            });
        }
    };
    $scope.checkcomfirm = function() {
        var impassed=false;
        angular.forEach($scope.reports, function(report, index) {
            if (impassed || !report.statement || !report.statement.length > 0) {
                impassed=true;
            }
            if (impassed || !report.keywords || !report.keywords.length > 0) {
                impassed=true;
            }
        });
        return impassed;
    }
    $scope.viewReport = function(report) {
        $scope.showcheckpage = false;
        $scope.report = report;
        commandService.invoke('getPlanReplieChilds', { ReportId: report.REPORTID }).then(function(data) {
            $scope.replies = data.REPORT_REPLIESINFO;
        });
    };
    $scope.cancelview = function() {
        $scope.showcheckpage = true;
    }
    $scope.editReport = function(report) {
        report.editing = true;
        if (report.SelectedContent) return;
        report.SelectedContent = angular.element(report.CONTENT).text();
    };
    $scope.saveReport = function(report) {
        report.editing = false;
    }

    $scope.deleteReport = function(report) {
        var arr = [];
        angular.forEach($scope.reports, function(item, idx) {
            if (item != report) arr.push(item);
        })
        $scope.reports = arr;
    }
    //检验关键词的总个数和总记录长度
    $scope.invalidTag = function(report,tag){
        var reg = /^[^<>\/,]*$/;
        if (tag.name.length > 10) {
            report.isShowKeywordTips = true;
            report.keywordsTips = "关键词长度不能超过10";
        }
        if (!reg.test(tag.name)) {
            report.isShowKeywordTips = true;
            report.keywordsTips = "不能包含特殊字符";
        }
    }; 
    $scope.hidetip = function(report){ 
            report.isShowKeywordTips = false;
            report.keywordsTips = "";
    }; 
    $scope.enter = function(report){ 
            report.focus = true; 
    }; 
    $scope.leave = function(report){ 
            report.focus = false; 
    };

    init();
})
